import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    if (!event.target.open) return

    this.element.querySelectorAll("details").forEach(details => {
      if (details !== event.target) details.open = false
    })
  }
}
